import { FrenetDeliveryMethodType } from "../../../contexts/OrderContext";
import api from "../../../services/api";
import { VolumeFrenetType } from "../../NewOrderInfo/newOrderInfo.type";
import { StoresType } from "../newCheckout.type";
 
 

// funcoes de cep e qualquer coisa relacionada a endereço (frenet, correios, etc)
export function cepHelper() {

    async function validCep(cep: string): Promise<boolean> {
        return await api
            .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
            .then((response) => {
                if (response.data.erro) {
                    return false;
                }
                return true;
            })
            .catch(() => {
                return false;
            });
    }

    async function verifyFrenet(cep: string, produtos: any, token: string, defaultValues: { defaultHeight: string, defaultDeep: string, defaultWeight: string, defaultWidth: string }): Promise<any> {
        try {
            if (!cep || !produtos || produtos.length === 0 || !token) {
                return []
            }
            let volumes: VolumeFrenetType[] = [];
            let shipmentInvoiceValue = 0;
            const { defaultHeight, defaultDeep, defaultWeight, defaultWidth } = defaultValues;
            produtos.forEach((prod: any) => {
                volumes.push({
                    Height: prod.measures?.height || Number(defaultHeight),
                    Length: prod.measures?.lenght || Number(defaultDeep),
                    Weight: prod.measures?.weight || Number(defaultWeight),
                    Width: prod.measures?.width || Number(defaultWidth),
                    Quantity: prod.quantity,
                    SKU: prod.sku,
                });
                shipmentInvoiceValue +=
                    prod.unitPrice !== prod.promotionalPrice &&
                        prod.promotionalPrice !== 0
                        ? prod.promotionalPrice
                        : prod.unitPrice;
            });
            return await api
                .post(
                    "/api/frenet/quote",
                    {
                        recipientCep: cep,
                        shipmentInvoiceValue,
                        shippingItemArray: volumes,
                        recipientCountry: "BR",
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                .then(async (response) => {
                    const frenetResponse = response.data;
                    if (
                        frenetResponse.success &&
                        frenetResponse.data &&
                        frenetResponse.data.ShippingSevicesArray &&
                        frenetResponse.data.ShippingSevicesArray.length > 0
                    ) {
                        const newFrenetItens =
                            frenetResponse.data.ShippingSevicesArray.filter(
                                (frenetItem: FrenetDeliveryMethodType) => !frenetItem.Error
                            );

                        return newFrenetItens;
                    } else {
                        return [];
                    }
                })
                .catch((err) => {
                    console.log(err);
                    return [];
                });

        } catch (err) {
            console.log(err);
            return [];
        }

    }

    async function findCepDeveryAndValue(token: string, urlSearchValid: string,): Promise<{
        success: boolean;
        data: {
            findCep: boolean;
            valueCep: number;
            canWithdraw: boolean;
        };
    }> {
        try {
            return await api
                .get(urlSearchValid, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then(async (response) => {
                    const findedCeps = response.data.data;

                    if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
                        return {
                            success: true,
                            data: {
                                findCep: true,
                                valueCep: findedCeps[0].valor,
                                canWithdraw: true
                            }
                        };
                    } else {
                        return {
                            success: false,
                            data: {
                                findCep: false,
                                valueCep: 0,
                                canWithdraw: false
                            }
                        };
                    }

                })
                .catch((err) => {

                    console.log(err);
                    return {
                        success: false,
                        data: {
                            findCep: false,
                            valueCep: 0,
                            canWithdraw: false
                        }
                    };
                });
        } catch (err) {
            console.log(err)
            return {
                success: false,
                data: {
                    findCep: false,
                    valueCep: 0,
                    canWithdraw: false
                }
            }
        }
    }

    /*Função usada para verificar se o cep é valido e se retorna as Lojas internas */
    async function getStoresByCep(token: string, cep: string, restrictCep: string, noStock: boolean, locationId: string, latLng?: any): Promise<{ success: boolean, data: any[] , emptyProducts?: any[] }> {
        try {
            return await api
                .post(
                    `/api/variations/skuzipcode`,
                    {
                        zipcode: cep,
                        skus: [],
                        restrictCep: restrictCep || "cep",
                        noVerifyStock: noStock,
                        locationId: locationId || null,
                        latLng: latLng || null,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                .then(async (response) => {
                    let newStores: Array<StoresType> = [];
                    if (!response.data || response.data.success === false) {
                        return {
                            success: false,
                            data: [],
                            emptyProducts: response.data.dataEmpty
                        }
                    }
                    // Filtrando lojas
                    response.data.forEach((str: StoresType) => {
                        const newStore = {
                            id: str.id,
                            name: str.name,
                            city: str.city,
                            district: str.district,
                            street: str.street,
                            number: str.number,
                            distance: str.distance,
                            currentBalance: str.currentBalance,
                        };
                        const findedStore = newStores.find(
                            (findStore) =>
                                findStore.name === newStore.name &&
                                findStore.distance === newStore.distance
                        );
                        if (!findedStore) {
                            newStores.push(newStore);
                            localStorage.setItem("storeAddress", JSON.stringify(newStore));
                        }


                    });
                    return {
                        success: true,
                        data: newStores
                    }

                })
                .catch((err) => {
                    console.log(err);
                    return {
                        success: false,
                        data: []
                    }
                });
        } catch (err) {
            console.log(err)
            return {
                success: false,
                data: []
            }
        }
    }



    return {
        validCep,
        verifyFrenet,
        findCepDeveryAndValue,
        getStoresByCep
    }
}